import { MultiSelect } from 'primereact/multiselect';

function AnalyticsFilter({ label, options, value, onChange, emptyLabel, optionLabel, showFilter }) {
  return (
    <div className="flex flex-col gap-y-1 w-full">
      <label className="text-slate-600">{label}</label>
      <MultiSelect
        value={value}
        onChange={(e) => onChange(e.target.value)}
        options={options}
        optionLabel={optionLabel || 'label'}
        placeholder={emptyLabel}
        scrollHeight={'350px'}
        className={`items-center text-sm w-full`}
        showSelectAll={false}
        filter={showFilter}
        maxSelectedLabels={2}
        selectedItemsLabel={`${value.length} sélectionnés`}
        showClear
      />
    </div>
  );
}

export default AnalyticsFilter;
